import { getCodeRepositoryName } from "@/domain/image"
import { getIssuesCountMapOrderedSeverity } from "@/domain/vulnerability"
import {
  DEFAULT_LONG_FORMAT,
  getDateFromSeconds,
  getDateInUserLocale
} from "@/helpers/date.helpers"
import { getBooleanValuesFromInsights } from "@/helpers/insights.helper"
import { capitalizeFirstLetter } from "@/helpers/string.helpers"
import { getLastDetectedCellData } from "@/helpers/table.helpers"
import { CODE_REPOSITORY_DRAWER_ID } from "@/organisms/Drawers/const"
import { getApplicationsMetaData } from "@/pages/TriagePage/application/useTriage.selector"
import { getBaseImageProperty } from "../../utils/inventory.utils"

import type { ImageResponse } from "@/api/useInventory.types"

export const getImageTabData = (response: ImageResponse) => {
  const { data = [], metadata } = response || {}

  return {
    metadata,
    data: data.map((record) => {
      const { data: dataRecord, id, displayName, type } = record || {}
      const { applications = [], issuesSummary, insights } = dataRecord
      const codeRepositories = (dataRecord.codeRepositoriesData || []).map(
        (codeRepository) => ({
          name: codeRepository.name,
          drawerId: CODE_REPOSITORY_DRAWER_ID,
          drawerEntityId: codeRepository.repositoryId
        })
      )
      const baseImageDisplayNames = getBaseImageProperty(
        dataRecord.baseImagesData,
        "displayName"
      )
      const issuesCounts = getIssuesCountMapOrderedSeverity(issuesSummary)
      return {
        key: id,
        type,
        displayName,
        applicationsCount: getApplicationsMetaData(applications),
        ...dataRecord,
        codeRepositoriesDisplayValue: {
          copyable: true,
          items: codeRepositories,
          count: codeRepositories.length - 1,
          label: getCodeRepositoryName(codeRepositories[0]?.name)
        },
        baseImageName: {
          copyable: true,
          count: baseImageDisplayNames.length - 1,
          items: baseImageDisplayNames,
          label: baseImageDisplayNames[0] || "",
          width: "100%"
        },

        fullImageName: `${dataRecord.registry}/${dataRecord.repository}:${dataRecord.tag}`,
        digestShort: dataRecord.digest?.substring(7, 19),
        operatingSystems: capitalizeFirstLetter(dataRecord.os),
        firstSeen: getDateInUserLocale(
          getDateFromSeconds(Number(dataRecord.firstSeen)),
          DEFAULT_LONG_FORMAT
        ),
        severity: issuesCounts,
        insights: getBooleanValuesFromInsights(insights),
        ...getLastDetectedCellData(record)
      }
    })
  }
}

export type ImageTabData = ReturnType<typeof getImageTabData>["data"][number]
